<div class="d-flex justify-content-between">
  <div *ngIf="view === 'my'">
    <h2 i18n="my projects title@@my-projects-title" class="widget-header">My projects</h2>
    <span class="text-muted" i18n="my projects description@@my-projects-description">Shows projects where you are a member.</span>
  </div>
  <div *ngIf="view === 'managed'">
    <h2 i18n="managed projects title@@managed-projects-title" class="widget-header">Projects I manage</h2>
    <span class="text-muted" i18n="managed projects description@@managed-projects-description">Show projects where you are the project manager.</span>
  </div>
  <div *ngIf="view === 'all'">
    <h2 i18n="all projects title@@all-projects-title" class="widget-header">All projects</h2>
    <span class="text-muted" i18n="all projects description@@all-projects-description">Search for all projects at RISE.</span>
  </div>
</div>

<div class="mt-4">
  <div class="row">
    <div class="col-12">

      <mat-slide-toggle class="advanced-search-toggle" (change)="toggleAdvancedSearch()" i18n="@@advanced-search-toggle" color="primary" [(ngModel)]="showAdvancedSearch">Advanced Search</mat-slide-toggle>

      <!-- Advanced search -->
      <div *ngIf="showAdvancedSearch === true" class="mat-elevation-z2 advanced-search">

        <div class="container mb-2 advanced-search-form-container">

          <div class="container mb-2 advanced-search-column">

            <mat-form-field appearance="outline" style="margin-bottom: -0.75rem">
              <mat-label i18n="@@advanced-search-field-project-id">Project ID</mat-label>
              <input [(ngModel)]="searchFieldProjectId" (ngModelChange)="modelChanged()" #inputProjectId matInput i18n-placeholder="@@advanced-search-field-project-id" placeholder="Project ID">
              <span matSuffix class="form-field-icon-suffix">
                <button (click)="searchFieldProjectId=undefined; modelChanged();" mat-button *ngIf="searchFieldProjectId" matSuffix class="form-field-icon-suffix" mat-icon-button i18n-aria-label="@@projects-search-clear" aria-label="Clear">
                  <mat-icon>close</mat-icon>
                </button>
              </span>
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-bottom: -0.75rem">
              <mat-label i18n="@@advanced-search-field-name">Project Name</mat-label>
              <input [(ngModel)]="searchFieldName" (ngModelChange)="modelChanged()" #inputProjectName matInput i18n-placeholder="@@advanced-search-field-name" placeholder="Name">
              <span matSuffix class="form-field-icon-suffix">
                <button (click)="searchFieldName=undefined; modelChanged();" mat-button *ngIf="searchFieldName" mat-icon-button i18n-aria-label="@@projects-search-clear" aria-label="Clear">
                  <mat-icon>close</mat-icon>
                </button>
              </span>
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-bottom: -0.75rem">
              <mat-label i18n="@@advanced-search-field-description">Project Description</mat-label>
              <input [(ngModel)]="searchFieldDescription" (ngModelChange)="modelChanged()" #inputProjectDescription matInput i18n-placeholder="@@advanced-search-field-description" placeholder="Description">
              <span matSuffix class="form-field-icon-suffix">
                <button (click)="searchFieldDescription=undefined; modelChanged();" mat-button *ngIf="searchFieldDescription" matSuffix class="form-field-icon-suffix" mat-icon-button i18n-aria-label="@@projects-search-clear" aria-label="Clear">
                  <mat-icon>close</mat-icon>
                </button>
              </span>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="view !== 'managed'">
              <span matPrefix>
                <mat-icon style="color: rgba(0, 0, 0, 0.54); margin-right: 0.25rem;">person</mat-icon>
              </span>
              <span matSuffix class="form-field-icon-suffix">
                <mat-spinner class="spinner-icon" *ngIf="managerSearch_IsSearching" [diameter]="15"></mat-spinner>
              </span>
              <span matSuffix class="form-field-icon-suffix">
                <button (click)="setSearchFieldManager(null)" mat-button *ngIf="searchFieldManager && !managerSearch_IsSearching" class="form-field-icon-suffix" mat-icon-button i18n-aria-label="@@projects-search-clear" aria-label="Clear">
                  <mat-icon>close</mat-icon>
                </button>
              </span>
              <mat-label i18n="@@advanced-search-field-manager">Manager</mat-label>
              <input [formControl]="managerControl" i18n-placeholder="@@advanced-search-field-manager" placeholder="Manager" matInput [matAutocomplete]="autoCompleteManager">
              <mat-hint align="end" *ngIf="managerSearch_NothingFound" i18n="@@no-user-found">no users found</mat-hint>
              <mat-autocomplete #autoCompleteManager="matAutocomplete" autoActiveFirstOption (optionSelected)="setSearchFieldManager($event)" [displayWith]="getDisplayName" panelWidth="1">
                <ng-container *ngIf="managerSearch_FoundUsers$ | async as foundUsers">
                  <mat-option *ngFor="let user of foundUsers" [value]="user" style="font-size: medium;">
                    <mat-icon class="mr-1">person</mat-icon>
                    {{user.displayName}} <small *ngIf="user.userPrincipalName" class="text-muted">({{user.userPrincipalName}})</small>
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </mat-form-field>

          </div>
          <div class="container mb-2 advanced-search-column">

            <mat-form-field appearance="outline" style="margin-bottom: -0.75rem">
              <mat-label i18n="@@advanced-search-field-customer">Customer</mat-label>
              <input [(ngModel)]="searchFieldCustomer" (ngModelChange)="modelChanged()" #inputProjectCustomer matInput i18n-placeholder="@@advanced-search-field-customer" placeholder="Customer">
              <span matSuffix class="form-field-icon-suffix">
                <button (click)="searchFieldCustomer=undefined; modelChanged();" mat-button *ngIf="searchFieldCustomer" matSuffix class="form-field-icon-suffix" mat-icon-button i18n-aria-label="@@projects-search-clear" aria-label="Clear">
                  <mat-icon>close</mat-icon>
                </button>
              </span>
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-bottom: -0.75rem">
              <mat-label i18n="@@advanced-search-field-cost-center">Cost Center</mat-label>
              <input [(ngModel)]="searchFieldCostCenter" (ngModelChange)="modelChanged()" #inputProjectCostCenter matInput i18n-placeholder="@@advanced-search-field-cost-center" placeholder="Cost Center">
              <span matSuffix class="form-field-icon-suffix">
                <button (click)="searchFieldCostCenter=undefined; modelChanged();" mat-button *ngIf="searchFieldCostCenter" matSuffix class="form-field-icon-suffix" mat-icon-button i18n-aria-label="@@projects-search-clear" aria-label="Clear">
                  <mat-icon>close</mat-icon>
                </button>
              </span>
            </mat-form-field>

          </div>
          <div class="container mb-2 advanced-search-column">

            <mat-form-field appearance="outline" style="margin-bottom: -1.25rem">
              <mat-label i18n="@@advanced-search-field-start-date-from">Start Date: From</mat-label>
              <input matInput [matDatepicker]="pickerStartDateFrom" [(ngModel)]="searchFieldStartDateFrom" (ngModelChange)="modelChanged()" [max]="searchFieldStartDateTo">
              <mat-datepicker-toggle matSuffix [for]="pickerStartDateFrom"></mat-datepicker-toggle>
              <mat-datepicker #pickerStartDateFrom startView="multi-year" [startAt]="searchFieldStartDateFrom"></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label i18n="@@advanced-search-field-start-date-to">Start Date: To</mat-label>
              <input matInput [matDatepicker]="pickerStartDateTo" [(ngModel)]="searchFieldStartDateTo" (ngModelChange)="modelChanged()" [min]="searchFieldStartDateFrom">
              <mat-datepicker-toggle matSuffix [for]="pickerStartDateTo"></mat-datepicker-toggle>
              <mat-datepicker #pickerStartDateTo startView="multi-year" [startAt]="searchFieldStartDateTo"></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-bottom: -1.25rem">
              <mat-label i18n="@@advanced-search-field-end-date-from">End Date: From</mat-label>
              <input matInput [matDatepicker]="pickerEndDateFrom" [(ngModel)]="searchFieldEndDateFrom" (ngModelChange)="modelChanged()" [max]="searchFieldEndDateTo">
              <mat-datepicker-toggle matSuffix [for]="pickerEndDateFrom"></mat-datepicker-toggle>
              <mat-datepicker #pickerEndDateFrom startView="multi-year" [startAt]="searchFieldEndDateFrom"></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label i18n="@@advanced-search-field-end-date-to">End Date: To</mat-label>
              <input matInput [matDatepicker]="pickerEndDateTo" [(ngModel)]="searchFieldEndDateTo" (ngModelChange)="modelChanged()" [min]="searchFieldEndDateFrom">
              <mat-datepicker-toggle matSuffix [for]="pickerEndDateTo"></mat-datepicker-toggle>
              <mat-datepicker #pickerEndDateTo startView="multi-year" [startAt]="searchFieldEndDateTo"></mat-datepicker>
            </mat-form-field>

          </div>
          <div class="container mb-2 advanced-search-column">

            <mat-form-field appearance="outline" style="margin-bottom: -0.75rem">
              <mat-label i18n="@@advanced-search-field-type">Type</mat-label>
              <mat-select [(ngModel)]="searchFieldHierarchical" (ngModelChange)="modelChanged()">
                <mat-option i18n="@@advanced-search-field-type-any">Any</mat-option>
                <mat-option value="root" i18n="@@advanced-search-field-type-base-project">Base Project</mat-option>
                <mat-option value="sub" i18n="@@advanced-search-field-type-sub-project">Sub-Project</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-bottom: -0.75rem">
              <mat-label i18n="@@advanced-search-field-status">Status</mat-label>
              <mat-select [(ngModel)]="searchFieldActivityStatus" (ngModelChange)="modelChanged()">
                <mat-option i18n="@@advanced-search-field-status-any">Any</mat-option>
                <mat-option value="active" i18n="@@advanced-search-field-status-active">Active</mat-option>
                <mat-option value="inactive" i18n="@@advanced-search-field-status-inactive">Inactive</mat-option>
              </mat-select>
            </mat-form-field>


            <mat-form-field appearance="outline" style="margin-bottom: -0.75rem">
              <mat-label i18n="@@advanced-search-field-info-class">Info Class</mat-label>
              <mat-select [(ngModel)]="searchFieldInfoClass" (ngModelChange)="modelChanged()">
                <mat-option i18n="@@advanced-search-field-info-class-any">Any</mat-option>
                <mat-option value="0" i18n="@@advanced-search-field-info-class-not-set">Not Set</mat-option>
                <mat-option value="1" i18n="@@advanced-search-field-info-class-k1">K1 - Open</mat-option>
                <mat-option value="2" i18n="@@advanced-search-field-info-class-k2">K2 - Internal</mat-option>
                <mat-option value="3" i18n="@@advanced-search-field-info-class-k3">K3 - Sensitive</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" style="margin-bottom: -0.75rem">
              <mat-label i18n="@@advanced-search-field-retention">Retention</mat-label>
              <mat-select [(ngModel)]="searchFieldRetention" (ngModelChange)="modelChanged()">
                <mat-option i18n="@@advanced-search-field-retention-any">Any</mat-option>
                <mat-option value="0" i18n="@@advanced-search-field-retention-not-set">Not Set</mat-option>
                <mat-option value="7"  i18n="@@advanced-search-field-retention-7years">7 Years</mat-option>
                <mat-option value="10"  i18n="@@advanced-search-field-retention-10years">10 Years</mat-option>
                <mat-option value="30" i18n="@@advanced-search-field-retention-30years">30 Years</mat-option>
                <mat-option value="-1" i18n="@@advanced-search-field-retention-forerver">Forever</mat-option>
              </mat-select>
            </mat-form-field>

          </div>
        </div>

        <div class="small wildcard-hint">
          <mat-icon class="small wildcard-hint-icon">info</mat-icon><span i18n="@@advanced-search-wildcard-hint-1">Use</span>&nbsp;<span class="small wildcard-hint-asterisk">*</span>&nbsp;<span i18n="@@advanced-search-wildcard-hint-2">as wildcard in text fields.</span>
        </div>

        <div class="container mb-2 text-center">
          <button (click)="submitAdvancedSearch()" mat-flat-button [disabled]="advancedSearchButtonEnabled == false" color="primary" class="py-1"><mat-icon>search</mat-icon> <span i18n="@@search">Search</span></button>
        </div>

      </div>



      <!-- Filters Section -->
      <div *ngIf="showAdvancedSearch === false">
        <div class="container mb-2">

          <!-- Filter Search Box -->
          <div class="row filters">
            <mat-form-field appearance="fill" class="project-search-box">
              <mat-label i18n="@@projects-search-label">Find project</mat-label>
              <input [(ngModel)]="searchValue" #projectSearch matInput i18n-placeholder="@@projects-search-placeholder" placeholder="Search for any project data">
              <button (click)="searchValue=''; fetchProjects();" mat-button *ngIf="searchValue" matSuffix mat-icon-button i18n-aria-label="@@projects-search-clear" aria-label="Clear">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <!-- Filter Buttons -->
          <div class="row" style="display: flex; justify-content: flex-end;">

            <!-- Filter Toggles-->
            <mat-slide-toggle class="mt-2" (change)="fetchProjects()" i18n="@@filter-toggle-subprojects" color="primary" [(ngModel)]="showSubProjects">Show sub-projects</mat-slide-toggle>

            <mat-slide-toggle class="mt-2 ml-5" (change)="fetchProjects()" i18n="@@filter-toggle-active" color="primary" [(ngModel)]="showInactive">Show inactive projects</mat-slide-toggle>
            <i matTooltip="Activate to show projects that have not yet been started in IFS, and also archived projects." i18n-matTooltip="@@filter-toggle-active-tooltip" class="show-inactive-help mt-2 ml-1 mr-3"><mat-icon matSuffix>help</mat-icon></i>

            <!-- Refresh Button-->
            <button mat-stroked-button color="primary" (click)="refreshData()" matTooltip="Refresh the list to show the latest changes." i18n-matTooltip="@@button-refresh-tooltip" class="ml-4"><mat-icon matSuffix>autorenew</mat-icon></button>
          </div>
        </div>
      </div>

      <div *ngIf="showMoreResultsAvailableLabel === true" class="alert alert-warning mt-3 mb-3" style="">
          <span><strong>Showing the first {{queryLimit}} projects.</strong></span>
          <br />
          <span>Refine your search if you did not find what you are looking for.</span>
      </div>

      <!-- Project Table -->
      <!-- removed matSort from table and mat-sort-header from th:s -->
      <table mat-table matSort class="mat-elevation-z2 mt-4" [dataSource]="projectsDataSource" *ngIf="projectsDataSource.filteredData.length > 0">

        <!-- Edit Project Menu -->
        <ng-container matColumnDef="EditProjectMenu">
          <th mat-header-cell *matHeaderCellDef disableClear class=""></th>
          <td mat-cell *matCellDef="let project" class="column-edit-project-menu px-1">
            <div *ngIf="showProjectContextMenu(project)">
              <button mat-icon-button [matMenuTriggerFor]="editMenu">
                <mat-icon class="text-muted">more_vert</mat-icon>
              </button>
              <mat-menu #editMenu="matMenu" class="edit-menu">
                <button mat-menu-item [routerLink]="'/edit-project-retention/' + project.PdpProjectId" >
                  <mat-icon>alarm</mat-icon>
                  <span i18n="@@project-context-menu-edit-retention">Change project retention</span>
                </button>
                <button mat-menu-item [routerLink]="'/edit-project-infoclass/' + project.PdpProjectId">
                  <mat-icon>lock</mat-icon>
                  <span i18n="@@project-context-menu-edit-infoclass">Change project infoclass</span>
                </button>
              </mat-menu>
            </div>
          </td>
        </ng-container>


        <!-- Project Id Column -->
        <ng-container matColumnDef="ProjectId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-project-number" i18n="@@column-project-number">Project ID</th>
          <td mat-cell *matCellDef="let project" class="column-project-number">
            <span *ngIf="project.OriginProjectId" [matTooltip]="oldProjectToolTipText + project.OriginProjectId">{{project.ProjectId}}</span>
            <span *ngIf="!project.OriginProjectId">{{project.ProjectId}}</span>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="Name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-name" i18n="@@column-project-name">Project</th>
          <td mat-cell *matCellDef="let project" class="column-name">
            <div>
              <strong>{{project.Name}}</strong>

              <!-- Project Description Icon (Project Description in Tooltip) -->
              <i *ngIf="project.Description"
                 matTooltip="{{project.Description}}"
                 matTooltipPosition="right"
                 matTooltipClass="description-tooltip"
                 (mouseenter)="$event.stopImmediatePropagation()"
                 (mouseleave)="$event.stopImmediatePropagation()"
                 #descriptionTooltip="matTooltip"
                 (click)="descriptionTooltip.toggle()"
                 class="material-icons project-description">info</i>

            </div>

            <!-- Action links for project managers -->
            <div *ngIf="showManagerActions(project)">
              <div *ngIf="canCloseProject(project)">
                <!--<small>-->
                <a [routerLink]="'/close-project/' + project.PdpProjectId" i18n="@@link-close-project">Close project</a>
                <!--</small>-->
              </div>
              <div *ngIf="canArchiveProject(project)">
                <!--<small>-->
                <a [routerLink]="'/archive-project/' + project.PdpProjectId" i18n="@@link-archive-project">Archive project</a>
                <!--</small>-->
              </div>
            </div>


          </td>
        </ng-container>

        <!-- InfoClass Column -->
        <ng-container matColumnDef="InfoClass">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-infoclass" i18n="@@column-infoclass">InfoClass</th>
          <td mat-cell *matCellDef="let project" class="column-infoclass text-center">
            <div *ngIf="project.InfoClass === 0">
              <span i18n="@@infoclass-open">Open</span>
            </div>
            <div *ngIf="project.InfoClass !== null && project.InfoClass > 0">
              K{{project.InfoClass}}
            </div>

          </td>
        </ng-container>


        <!-- Project Manager Column -->
        <ng-container matColumnDef="ProjectManager">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-project-manager" i18n="@@column-project-manager">Project manager</th>
          <td mat-cell *matCellDef="let project" class="column-project-manager">
            <div *ngFor="let mngr of project.Managers">
              <ng-container *ngIf="mngr.MsGraphUser$ | async as msGraphUser; else noUser">
                <span matTooltip="{{msGraphUser.mail ? msGraphUser.mail : msGraphUser.userPrincipalName}}">{{msGraphUser.displayName}}</span><br />
              </ng-container>
              <ng-template #noUser>
                {{mngr.UpnId}}
              </ng-template>
            </div>
          </td>
        </ng-container>

        <!-- Cost Center Column -->
        <ng-container matColumnDef="CostCenter">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-cost-center" i18n="@@column-cost-center">Cost center</th>
          <td mat-cell *matCellDef="let project" class="column-cost-center">
            <!--<small>-->{{project.CostCenter}}<!--</small>-->
          </td>
        </ng-container>

        <!-- Customer Column -->
        <ng-container matColumnDef="Customer">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-customer" i18n="@@column-customer">Customer</th>
          <td mat-cell *matCellDef="let project" class="column-customer">
            <!--<small>-->{{project.Customer}}<!--</small>-->
          </td>
        </ng-container>

        <!-- Start Date Column -->
        <ng-container matColumnDef="StartDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-start-date" i18n="@@column-start-date">Start date</th>
          <td mat-cell *matCellDef="let project" class="column-start-date">
            <span *ngIf="isValidDate(project.StartDate)">
              <!--<small>-->{{project.StartDate | date: 'yyyy-MM-dd'}}<!--</small>-->
            </span>
          </td>
        </ng-container>

        <!-- End Date Column -->
        <ng-container matColumnDef="EndDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-end-date" i18n="@@column-end-date">End date</th>
          <td mat-cell *matCellDef="let project" class="column-end-date">
            <div *ngIf="isValidDate(project.EndDate)">
              <!--<small>-->{{project.EndDate | date: 'yyyy-MM-dd'}}<!--</small>-->
            </div>
          </td>
        </ng-container>

        <!-- Retention Column -->
        <ng-container matColumnDef="Retention">
          <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="column-retention" i18n="@@column-retention">Retention</th>
          <td mat-cell *matCellDef="let project" class="column-retention">
            <div *ngIf="project.Retention === -1">
              <span i18n="@@retention-forever">Forever</span>
            </div>
            <div *ngIf="project.Retention !== null && project.Retention > -1">
              {{project.Retention}} <span i18n="@@retention-years">years</span>
            </div>
          </td>
        </ng-container>

        <!-- SharePoint Button Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="text-right column-action" i18n="@@column-project-area">Project Area</th>
          <td mat-cell *matCellDef="let project" class="column-action">

            <div *ngIf="getSiteStatus(project) === 'canconnect'">
              <a [routerLink]="'/connect-project/' + project.PdpProjectId" i18n="@@link-connect-to-o365">Create/connect project area</a>
            </div>

            <div *ngIf="getSiteStatus(project) === 'ongoing'">
              <a mat-raised-button class="" target="_blank" [href]="project.SiteUrl">
                <i aria-hidden="true" class="ms-Icon ms-BrandIcon--icon96 ms-BrandIcon--sharepoint link-button-icon-with-text"></i>
                <ng-container i18n="Open in SharePoint button in project table@@button-open-sharepoint">Open project area</ng-container>
              </a>
            </div>

            <div *ngIf="getSiteStatus(project) === 'preparing'" i18n="@@project-site-provisioning-in-progress">Project area is being prepared...</div>

            <div *ngIf="getSiteStatus(project) === 'closed'">
              <span class="" i18n="@@project-site-provisioning-closed">Closed</span>
              <a mat-raised-button class="ml-2" target="_blank" [href]="project.SiteUrl" i18n-title="Open in SharePoint button in project table@@button-open-sharepoint" title="Open in SharePoint">
                <i aria-hidden="true" class="ms-Icon ms-BrandIcon--icon96 ms-BrandIcon--sharepoint link-button-icon"></i>
              </a>
            </div>

            <div *ngIf="getSiteStatus(project) === 'closing'" i18n="@@project-site-closure-in-progress">Closing...</div>
            <div *ngIf="getSiteStatus(project) === 'archiving'" i18n="@@project-site-archiving-in-progress">Archiving...</div>

            <div *ngIf="getSiteStatus(project) === 'archived'">
              <span class="" i18n="@@project-site-provisioning-archived-on">Archived on</span> {{project.ArchiveDate | date: 'yyyy-MM-dd'}}
              <a mat-raised-button class="ml-2" target="_blank" [href]="project.SiteUrl" i18n-title="Open in SharePoint button in project table@@button-open-sharepoint" title="Open in SharePoint">
                <i aria-hidden="true" class="ms-Icon ms-BrandIcon--icon96 ms-BrandIcon--sharepoint link-button-icon"></i>
              </a>
            </div>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

      </table>

      <mat-paginator [hidden]="dataLoading || projectsDataSource.filteredData.length === 0"
                     class="mat-elevation-z2 mat-paginator-sticky"
                     [hidePageSize]="false"
                     [pageSizeOptions]="[5, 10, 25, 50, 100]"
                     showFirstLastButtons
                     itemsPerPageLabel="Visa"
                     (page)="onChangePage($event)">
      </mat-paginator>

      <div class="col-12 text-center mt-6" *ngIf="showNoResultLabel">
        <span class="align-middle" i18n="@@no-projects-found">Couldn't find any projects. </span>
        <mat-icon class="align-middle">sentiment_very_dissatisfied</mat-icon>
      </div>

      <div [className]="dataLoading ? 'fadeIn' : 'fadeOut'">
        <div *ngIf="dataLoading === true" class="mt-4 pt-4 mb-4 text-center">
          <div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
      </div>

      <!-- <div class="container position-absolute d-flex justify-content-center align-items-center mt-5 pt-5 mb-6">
        <div [className]="dataLoading ? 'fadeIn' : 'fadeOut'">
          <div class="lds-grid"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
      </div> -->

    </div>
  </div>
</div>


